import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import {TransferCommonDescription} from "../types/TransferCommonDescription";

type Output = TransferCommonDescription;

export default function useTransferParentInfoGet (
    id: string,
    options?: CacheQueryOpts
): CacheQueryOutput<Output> {
    const client = useAPIClient();
    return useCacheQuery<Output>(
        ["transfer-parent-info", id],
        () => {
            return client.get<any>(id.substring(1));
        },
        options
    );
}